export default __webpack_public_path__ + "static/media/fnnetwork.1d301f6f.png";